module.exports = __webpack_public_path__ + "fonts/Formular-Italic.b886fad.woff2";